import { useState } from "react";
import { subscribeNewsletter } from "@/lib/api";

export default function NewsletterInline() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await subscribeNewsletter(email);
      setStatus("done");
      setEmail("");
    } catch { setStatus("error"); }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="max-w-md">
      <div className="label-eyebrow">A slower letter</div>
      <p className="mt-3 text-[14px] text-[#55524C] leading-relaxed">
        Quiet notes on skin, breath and stillness — sent rarely, never sold.
      </p>
      <div className="mt-5 flex items-end gap-3 border-b border-[#D5CDBF] focus-within:border-[#2E2B27] transition-colors">
        <input
          type="email"
          required
          data-testid="newsletter-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 bg-transparent outline-none py-3 text-[15px]"
        />
        <button
          type="submit"
          data-testid="newsletter-submit"
          className="text-[11px] uppercase tracking-[0.24em] font-medium pb-3 text-[#2E2B27] hover:text-[#A96A53] transition-colors"
        >
          {status === "loading" ? "Sending" : status === "done" ? "Thank you" : "Subscribe"}
        </button>
      </div>
    </form>
  );
}
